import MtownR1 from '../../../media/Apartement/Mtown Residence/Mtown Residence (1).webp'
import MtownR2 from '../../../media/Apartement/Mtown Residence/Mtown Residence (2).webp'
import MtownR3 from '../../../media/Apartement/Mtown Residence/Mtown Residence (3).webp'
import MtownR4 from '../../../media/Apartement/Mtown Residence/Mtown Residence (4).webp'

const MtownRimages =[
MtownR1,MtownR2,MtownR3,MtownR4
]

export default MtownRimages;